module.exports = __webpack_public_path__ + "img/hr-heat-pipe-straight-vertical-3.e1b1f4e2.png";